import { Button } from '@accure/ui';
import { Menu } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import { useSidebar } from '@/providers/sidebar-context';

export function MenuToggleButton() {
  const { isOpen, toggleSidebar } = useSidebar();

  return (
    <Tooltip
      content={isOpen ? 'Hide sidebar' : 'Expand sidebar'}
      position="right"
      delay
    >
      <Button
        data-testid="menu-toggle-button"
        className="hover:bg-neutral-200/85"
        variant="ghost"
        size="icon"
        onClick={toggleSidebar}
      >
        <Menu className="size-5" />
      </Button>
    </Tooltip>
  );
}
